import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const PlacaFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='PLACA' htmlFor='input-placa' md={3} alignRightAt='md' />
      <Col md={9}>
        <Field name='placa'>
          {({ field }) => <Form.InputText {...field} isInvalid={iTouched && iError} disabled={fIsSubmitting} id='input-placa' />}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(PlacaFormGroup)
